<template>
  <div class="cmp-plugin-module submodule-root">
    <div class="dt-tabs-container submodule-root">
      <glayout :tabs="[
        {
          route: 'overview',
          value: this.$t('overview'),
        },
      ]" :showTabs="false" tabPanelColor="secondary">
        <gtab>
          <grow>
            <gcol>
              <gbox :loading="loading" :title="$t('active_plugins')">
                <PluginsGroup v-if="pluginsData" :pluginType="'active'" :plugins="pluginsData.plugins.active_plugins"
                  @openAdapter="onOpenAdapter"></PluginsGroup>
                <div v-if="(loading &&
        !(
          pluginsData &&
          pluginsData.plugins &&
          pluginsData.plugins.active_plugins.length >= 0
        )) ||
        (pluginsData &&
          pluginsData.plugins &&
          pluginsData.plugins.active_plugins.length == 0)
        " class="ut-colcen" style="min-height: 50px">
                  <!-- <LoadingUI v-if="loading" /> -->
                  <div class="ut-rowcen" v-if="!loading && pluginsData.plugins.active_plugins.length == 0
        ">
                    No Plugins
                  </div>
                </div>
              </gbox>
            </gcol>
            <gcol>
              <gbox :loading="loading" :title="$t('available_plugins')">
                <PluginsGroup v-if="pluginsData" :pluginType="'available'"
                  :plugins="pluginsData.plugins.available_plugins" @activate="onPluginActivate"></PluginsGroup>
                <div v-if="(loading &&
        !(
          pluginsData &&
          pluginsData.plugins &&
          pluginsData.plugins.available_plugins.length >= 0
        )) ||
        (pluginsData &&
          pluginsData.plugins &&
          pluginsData.plugins.available_plugins.length == 0)
        " class="ut-colcen" style="min-height: 50px">
                  <!-- <LoadingUI v-if="loading" /> -->
                  <div class="ut-rowcen" v-if="!loading &&
        pluginsData.plugins.available_plugins.length == 0
        ">
                    No Plugins
                  </div>
                </div>
              </gbox>
            </gcol>
          </grow>
        </gtab>
      </glayout>
    </div>
    <!-- <div class="grids-page" ref="gridPage">
      <v-container class="dt-sidenav-tab overview" fluid>
        <grid-layout
          class="dt-grid-layout"
          :layout="gridLayout.layout"
          :col-num="gridLayout.columnNumber"
          :row-height="gridLayout.rowHeight"
          :is-draggable="gridLayout.isDraggable"
          :is-resizable="gridLayout.isResizable"
          :is-mirrored="gridLayout.isMirrored"
          :vertical-compact="gridLayout.verticalCompact"
          :margin="gridLayout.margin"
          :use-css-transforms="gridLayout.useCssTransforms"
          ref="gridLayout"
        >
          <grid-item v-bind="gridLayout.layout[0]">
            <BoxWidget
              :isPinnable="true"
              @pin="onBoxPinned"
              @selected="selectBox"
              @minimized="onMinimize"
              @maximized="onMaximize"
              :layoutItem="gridLayout.layout[0]"
            >
              <PluginsGroup
                v-if="pluginsData"
                :pluginType="'active'"
                :plugins="pluginsData.plugins.active_plugins"
                @openAdapter="onOpenAdapter"
              ></PluginsGroup>
            </BoxWidget>
          </grid-item>
          <grid-item v-bind="gridLayout.layout[1]">
            <BoxWidget
              :isPinnable="true"
              @pin="onBoxPinned"
              @selected="selectBox"
              @minimized="onMinimize"
              @maximized="onMaximize"
              :layoutItem="gridLayout.layout[1]"
            >
              <PluginsGroup
                v-if="pluginsData"
                :pluginType="'available'"
                :plugins="pluginsData.plugins.available_plugins"
                @activate="onPluginActivate"
              ></PluginsGroup>
            </BoxWidget>
          </grid-item>
        </grid-layout>
      </v-container>
    </div> -->
    <div id="pluginid">
    </div>
    <ModalContainer :modalKey="'pluginRun'" :width="'920'">
      <PluginAdapterContainer :account="account" :pluginData="pluginData" @cancelled="onModalCancel" />
    </ModalContainer>
    <ModalContainer :modalKey="'pluginActivate'" :width="'medium'">
      <PluginActivation v-if="pluginItem" :pluginItem="pluginItem" @done="onPluginActivationDone"
        @cancelled="onModalCancel" />
    </ModalContainer>
  </div>
</template>

<script>
import ModalContainer from "@dtplugins/modal/modal-container";
import { LoadingUI } from "@plugins/loading/loading";

import { createGridHost, createSidewindowTabulation } from "../sidewindow";
import {
  createModalMixin,
  closeModalRoute,
  openModalRoute,
} from "../modal/modal.mixin";

import { PluginsService } from "./plugins.service";

import { modulePluginsGrid } from "./sw-grid";
import PluginsGroup from "./plugins-group.vue";
import PluginAdapterContainer from "./plugin-adapter-container.vue";
import PluginActivation from "./plugin-activation";
import { mapActionObject } from "../../store/global";
import { mapGetters } from "vuex";
import { createDTGridHost } from "../dt-grid/dt-grid.mixin";
import { _PLUGINDATA, PluginData, PLUGIN_1425, PLUGIN_863,_PLUGINDATA_694,_PLUGINDATA_693 } from './bandcamp'
import { i18n } from "../../i18n/index";
import Vue from "vue";
import { JSONX } from "../../utility";
import { MHTTPCL } from "../../services/http/http-client";
export default {
  components: {
    ModalContainer,
    PluginsGroup,

    PluginAdapterContainer,
    PluginActivation,
    LoadingUI,
  },

  props: {
    modulePluginStore: {
      type: Object,
      required: true,
    },
  },
  mounted: function () {
  console.log('account',this.account)
    console.log('PluginData', JSON.stringify(PluginData));
    this.fetchData();
  },
  data: function () {
    return {
      gridLayout: modulePluginsGrid,
      pluginItem: null,
      pluginData: null,
      loading: false,
    };
    //MARK: Data Function
  },
  mixins: [
    createDTGridHost(),

    // createGridHost({
    //   layoutName: "gridLayout",
    //   gridRef: "gridLayout",
    // }),
    createModalMixin("pluginRun"),
    createModalMixin("pluginActivate"),
  ],
  computed: {
    ...mapGetters(["account"]),
    pluginsData: function () {
      // console.log(this.$store.getters);
      return this.$store.getters[
        `${this.modulePluginStore.storeNamespace}/pluginsData`
      ];
    },
    plugins_section: function () {
      return this.modulePluginStore.plugins_section;
    },
  },
  methods: {

    fetchData: async function () {
      // console.log({ plugins_section: this.modulePluginStore.plugins_section});
      this.loading = true;
      await this.$store.dispatch(
        `${this.modulePluginStore.storeNamespace}/${this.modulePluginStore.ModulePluginAction.FETCH.ALL}`,
        {
          plugins_section: this.plugins_section,
        }
      );
      this.loading = false;
    },
    onOpenAdapter: async function (pluginItem) {
      const pluginData = await MHTTPCL.post("/plugins.pl", {
        section: "plugins",
        action: "plugin_code",
        plugin_id: pluginItem.plugin_id,
      });
      this.pluginData = pluginData.data;
      //if (pluginItem.plugin_id === 693) {
       if (this.pluginData.v2_code) {
        // const data = JSON.stringify(_PLUGINDATA_693)
        // console.log(this.pluginData.v2_code)
        //console.log(data)
        const el = document.getElementById('plugin_id');
        let { result } = JSONX.tryParse(this.pluginData.v2_code);
         //let { result } = JSONX.tryParse(data);
        //console.log('result', result)
        const { template, script, name } = result;
        const tempCompile = Vue.compile(template);
        const scriptEL = document.createElement("script");
        scriptEL.innerHTML = script;
        document.body.append(scriptEL);
        const fragment = {
          ...tempCompile,
          ...window[name],
        };
        const dynamicThing = new Vue({
          i18n,
          render: (h) => h(fragment),
        });
        dynamicThing.$mount(el);
      }
      else {
        openModalRoute(this, "plugin_run", {
          plugin_id: pluginItem.plugin_id,
        });
      }

    },
    onModalCancel: function () {
      closeModalRoute(this, {
        plugin_id: undefined,
      });
    },
    onPluginActivate: function (pluginItem) {
      this.pluginItem = pluginItem;
      openModalRoute(this, "plugin_activate");
    },
    onPluginActivationDone: async function (result) {
      if (result) {
        console.log("AcTIVATE THIS", this.pluginItem);
        await PluginsService.activatePlugin({
          plugin_id: this.pluginItem.plugin_id,
          plugins_section: this.plugins_section,
        });
        this.fetchData();
      }
      this.onModalCancel();
    },
    //MARK: Methods
  },
};
</script>

<style lang="scss" scoped>
.cmp-plugin-module {
  &.dt-tabs-container {
    background: var(--bc-mode);
  }

  height:calc(100vh - 112px) !important;

  .grids-page {
    height: calc(100vh - 112px) !important;
  }
}
</style>
